import { laoTableConstants } from "reduxLib/constants/LAO/laoTableConstants";
import get from "lodash/get";

const laoTableReducer = (state = {}, action) => {
    const { dataVariables } = action;
    const { type, tableName } = get(dataVariables, "body", {});
    switch (action.type) {
        case laoTableConstants.LAO_TABLE_SUCCESS:
        case laoTableConstants.LAO_TABLE_FAILED:
            return {
                ...state,
                [type]: {
                    ...(get(state, [type], {})),
                    [tableName]: {
                        ...(get(state, [type, tableName], {})),
                        data: action.payload,
                        payload: dataVariables,
                        status: action.status,
                        loading: false
                    }
                }
            };

        case laoTableConstants.LAO_TABLE_LOADING:
            return {
                ...state,
                [type]: {
                    ...(get(state, [type], {})),
                    [tableName]: {
                        ...(get(state, [type, tableName], {})),
                        loading: action.payload,
                    }
                }
            };

        default:
            return state
    }
}

export default laoTableReducer;
